export const SHOW_HUD = 'SHOW_HUD';
export const HIDE_HUD = 'HIDE_HUD';
export const DECK_SET_DEVICE_ROLE = 'DECK_SET_DEVICE_ROLE';
export const REGISTER_HUD_REF = 'REGISTER_HUD_REF';

export function showHUD () {
  return {
    type: SHOW_HUD
  };
}

export function hideHUD () {
  return {
    type: HIDE_HUD
  };
}

export function registerHUDRef (name, ref) {
  return {
    type: REGISTER_HUD_REF,
    name,
    ref
  };
}

export function setDeviceRole (role) {
  localStorage.setItem('deviceRole', role);
  return {
    type: DECK_SET_DEVICE_ROLE,
    role
  };
}



// WEBPACK FOOTER //
// ./src/actions/deckActions.js